import * as React from 'react'
import {Time} from 'yougile-util'
import {DataObjectId, shiftScheduleTime} from 'yougile-model'
import {BooleanHookState} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {Input} from './input'

interface Props {
  className: string
  hourUTC: number
  minuteUTC: number
  onChange: (hourUTC: number, minuteUTC: number) => void
  large?: boolean
  valid?: BooleanHookState
  id?: DataObjectId
}

const isTime = (s: string) => {
  return (
    !!s &&
    s.split(':').length === 2 &&
    s.split(':').filter(n => n.match(/^[0-9][0-9]?$/g)).length === 2 &&
    parseInt(s.split(':')[0], 10) >= 0 &&
    parseInt(s.split(':')[0], 10) < 24 &&
    parseInt(s.split(':')[1], 10) >= 0 &&
    parseInt(s.split(':')[1], 10) < 60
  )
}

const lz = (n: number) => ('00' + n).slice(-2)
const getTimeText = (hourUTC: number, minuteUTC: number) => {
  const localTime = shiftScheduleTime(
    {hour: hourUTC, minute: minuteUTC},
    Time.getTimeZoneDiff()
  )
  return lz(localTime.hour) + ':' + lz(localTime.minute)
}

const parseTime = (s: string) => {
  if (!isTime(s)) {
    return undefined
  }
  const [hour, minute] = s.split(':').map(p => +p)
  const timeLocal = {hour, minute}
  const utc = shiftScheduleTime(timeLocal, -Time.getTimeZoneDiff())
  return {hourUTC: utc.hour, minuteUTC: utc.minute}
}

export const TimeInput = (props: Props) => {
  const {onChange, className, hourUTC, minuteUTC, large, valid} = props
  const [text, setText] = React.useState(getTimeText(hourUTC, minuteUTC))

  React.useEffect(() => {
    setText(getTimeText(hourUTC, minuteUTC))
  }, [props.id])

  const change = (newText: string) => {
    if (text.length < 2 && newText.length >= 2 && !newText.includes(':')) {
      // insert : as 3rd symbol
      newText = [newText.slice(0, 2), ':', newText.slice(2)].join('')
    }
    const isValid = isTime(newText)
    if (isValid) {
      const time = parseTime(newText)
      onChange(time?.hourUTC || 0, time?.minuteUTC || 0)
    }
    valid?.setValue(isValid)
    setText(newText)
  }
  return (
    <Input
      className={cn(
        'w-64',
        !isTime(text) && 'border-error-old focus:border-error-old',
        className
      )}
      placeholder="00:00"
      value={text}
      onChange={change}
      large={large}
    />
  )
}
